export type GeneralState = {
    state: Map<string, any>;
};

export enum GENERAL_STATE_KEYS {
    SCRUBBING_INSIGHTS_TOGGLE = 'SCRUBBING_INSIGHTS_TOGGLE',
    AGING_INSIGHTS_TOGGLE = 'AGING_INSIGHTS_TOGGLE',
    POSTING_WORKLIST_FILTER = 'POSTING_WORKLIST_FILTER',
    POSTING_WORKLIST_DATE = 'POSTING_WORKLIST_DATE',
    TODO_FILTER = 'TODO_FILTER',
    TODO_PAGINATION = 'TODO_PAGINATION',
    NOTIFICATIONS_FILTER = 'NOTIFICATIONS_FILTER',
}
